import { createRoot } from "react-dom/client";
import React from "react";
import { ThemeProvider, createTheme } from '@mui/material';

import { App } from "./App.tsx";
import { AuthProvider } from "./auth/AuthProvider.tsx";
import { FirebaseAppProvider } from "./firebase/FirebaseAppProvider.tsx";

const rootEl = document.getElementById("app");

if (!rootEl) {
  throw new Error("No root element found");
}

const theme = createTheme({
    palette: {
        primary: {
            main: '#0d4c24'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        '--variant-textBg': 'rgba(0, 0, 0, 0.2)',
                        '--variant-outlinedBg': 'rgba(0, 0, 0, 0.2)',
                    }
                }
            }
        }
    }
});

const root = createRoot(rootEl);
root.render(
  <ThemeProvider theme={theme}>
    <FirebaseAppProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </FirebaseAppProvider>
  </ThemeProvider>
);
